export default "__VITE_ASSET__BpMDANBf__"